import "./HomeOwnerRentalSection.scss";
import iPhoneImg from "../../../iamges/iPhone.png";
import image1 from "../../../iamges/1.png";
import image2 from "../../../iamges/2.png";
import image3 from "../../../iamges/3.png";
import image4 from "../../../iamges/4.png";

const HomeOwnerRentalSection = () => {
  return (
    <div>
      <div className='homeOwnerRentalSection'>
        <h1 className='first-title'>
          Managing Rent & Tenants in Canada — Made Simple with
        </h1>

        <div className='white-bg-text-wrapper'>
          <h2 className='rental-text-white'>HomeOwner Rental</h2>
        </div>
      </div>

      <div className='position-relative'>
        <div className='text-center'>
          <img src={image1} alt='image1' className='side-image image1' />
          <img src={image2} alt='image2' className='side-image image2' />
          <img src={iPhoneImg} alt='iPhone' className='iPhone-img' />
          <img src={image3} alt='image3' className='side-image image3' />
          <img src={image4} alt='image4' className='side-image image4' />
        </div>
      </div>
    </div>
  );
};

export default HomeOwnerRentalSection;
